import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EmergencyCommandComponent } from './emergencyCommand/emergency-command.component';
import { EmergencyPositionComponent } from './emergencyPosition/emergency-position.component';

const routes: Routes = [
  {
    path: 'emergencyCommand',
    component: EmergencyCommandComponent,
  },
  {
    path: 'emergencyPosition',
    component: EmergencyPositionComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReportRoutingModule {}
